module.exports = __webpack_public_path__ + "static/media/Akemi_4320.228153c3.jpg";